import { OPERATOR_PORTFOLIO_PROPERTIES_MOCK } from './operator-portfolio.mock';
import type { OperatorPortfolioPropertiesDto } from './operator-portfolio.types';

/** Property table mock. KPI cards use the portfolio KPI mock until that API is on main. */
export const OperatorPortfolioService = {
  async getProperties(): Promise<OperatorPortfolioPropertiesDto> {
    await new Promise((resolve) => setTimeout(resolve, 150));
    return structuredClone(OPERATOR_PORTFOLIO_PROPERTIES_MOCK);
  },
};
